import { mapState } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import pullAt from 'lodash/pullAt';
import get from 'lodash/get';
export default {
  name: 'CoreDtwinRuleEditConditions',
  props: {
    rule: {
      type: Object,
      required: true
    },
    // the indicies in order to get to the nested conditions
    conditionIndicies: {
      type: Array,
      required: true
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    // the states that are to be displayed / edited
    states: {
      type: Array,
      required: true
    },
    templateContext: {
      type: Boolean,
      required: false,
      default: false
    },
    isCreatedByTemplate: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function () {
    return {
      logicalOperators: [{
        value: 'and',
        text: this.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.operations.and')
      }, {
        value: 'or',
        text: this.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.operations.or')
      }],
      comparisionOperators: [{
        value: 'eq',
        text: this.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.operations.eq')
      }, {
        value: 'not',
        text: this.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.operations.not')
      }, {
        value: 'lt',
        text: this.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.operations.lt'),
        type: 'numeric'
      }, {
        value: 'gt',
        text: this.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.operations.gt'),
        type: 'numeric'
      }, {
        value: 'lte',
        text: this.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.operations.lte'),
        type: 'numeric'
      }, {
        value: 'gte',
        text: this.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.operations.gte'),
        type: 'numeric'
      }]
      // javascript: null,
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme']),
    stateMetrics() {
      return get(this.rule, 'properties.stateMetrics', []);
    },
    conditions() {
      if (this.conditionIndicies.length === 0) {
        return this.rule.properties.conditions;
      }
      const indicies = this.conditionIndicies.map(i => `items[${i}]`);
      return get(this.rule, `properties.conditions.${indicies.join('.')}`);
    }
  },
  methods: {
    emitChange() {
      this.$emit('conditions-changed');
    },
    addCondition() {
      this.conditions.items.push({
        key: '',
        compOperator: 'eq',
        compValue: 0
      });
      this.emitChange();
    },
    addOperator() {
      this.conditions.items.push({
        type: 'and',
        items: []
      });
      this.emitChange();
    },
    removeCondition(index) {
      pullAt(this.conditions.items, [index]);
      this.conditions.items = cloneDeep(this.conditions.items);
      this.emitChange();
    },
    removeConditions() {
      this.$emit('remove');
      this.emitChange();
    },
    comparitionOperatorsForState(stateMetricKey) {
      if (stateMetricKey) {
        const stateMetric = get(this.rule, 'properties.stateMetrics', []).find(s => s.key === stateMetricKey);
        if (stateMetric) {
          const state = this.states.find(s => {
            if (this.templateContext) {
              return s.key === stateMetric.id;
            }
            if (this.isCreatedByTemplate) {
              return s.key === stateMetric.key;
            }
            return s.id === stateMetric.stateId;
          });
          return this.comparisionOperators.filter(op => {
            return get(state, 'properties.valueType') === 'number' || !op.type || stateMetric.operation === 'since_last_update';
          });
        }
      }
      return this.comparisionOperators;
    }
  }
};